var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M11 1.333h-1v-1a.333.333 0 0 0-.667 0v1H2.667v-1a.333.333 0 0 0-.667 0v1H1a1 1 0 0 0-1 1V11a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2.333a1 1 0 0 0-1-1ZM1 2h1v1a.333.333 0 1 0 .667 0V2h6.666v1A.333.333 0 1 0 10 3V2h1a.333.333 0 0 1 .333.333v2.334H.667V2.333A.333.333 0 0 1 1 2Zm10 9.333H1A.333.333 0 0 1 .667 11V5.333h10.666V11a.333.333 0 0 1-.333.333Z"
  })));
};
export default SvgCalendar;